import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { RunContext } from "components/Run/Context";
import useTypedContext from "hooks/useTypedContext";
import { ObservabilityProcessingStatus, Stack } from "types/generated";

import { GET_RUN_OBSERVABILITY_DATA } from "./gql";
import { getPhaseExecutionTimeBars } from "./PhaseExecutionTime/utils";
import { toRunObservabilityStatTiles } from "./StatTiles/utils";

export const useRunObservabilityData = () => {
  const { run, stack } = useTypedContext(RunContext);

  const { data, loading, error } = useQuery<{ stack: Stack }>(GET_RUN_OBSERVABILITY_DATA, {
    variables: { stackId: stack.id, runId: run.id },
    skip: run.observabilityStatus?.metrics !== ObservabilityProcessingStatus.Available,
  });

  const workerMetrics = data?.stack?.run?.workerMetrics;

  const bars = useMemo(
    () => (workerMetrics ? getPhaseExecutionTimeBars(workerMetrics.states) : []),
    [workerMetrics]
  );

  const tiles = useMemo(
    () => (workerMetrics ? toRunObservabilityStatTiles(workerMetrics) : []),
    [workerMetrics]
  );

  const comparison = workerMetrics?.comparison;
  const hasContent = bars.length > 0 || tiles.length > 0;

  return { bars, tiles, comparison, hasContent, loading, error };
};
